import _                              from 'underscore';
import React, { useEffect, useState } from 'react';
import { useQuery }                   from '@apollo/react-hooks';

import { runIfFunction }                                                         from '@src/util';
import { SystemAccountingQueries }                                               from '@src/queries';
import { Align, CorvalProjectTemplate, Size, Uuid }                              from '@src/types';
import { queriesHaveData, queriesLoading }                                       from '@src/store/_apolloUtil';
import { StyledContainer }                                                       from '@src/views/containers';
import { BasicDialogContainer }                                                  from '@src/views/components/modals/BasicDialogContainer';
import { LoadingIndicator }                                                      from '@src/views/components/util/loading/LoadingIndicator';
import { UseIf }                                                                 from '@src/views/components/display/EqualValues';
import { BasicDialog }                                                           from '@src/views/components/modals/BasicDialog';
import { TemplateListingWithSearch }                                             from '@src/views/pages/projects/operations/templates/TemplateListingWithSearch';
import { useProject }                                                            from '@src/hooks';
import { Modal }                                                                 from 'semantic-ui-react';
import { ProjectTemplateManagementDialog, ProjectTemplateManagementDialogProps } from '@src/views/pages/projects/operations/ProjectTemplateManagementDialog';


interface ProjectTemplatesManagementDialogProps {
    onComplete?: () => void,
}

const ProjectTemplatesManagementDialogDefaultProps = {
    onComplete: null
} satisfies Partial<ProjectTemplatesManagementDialogProps>;

function ProjectTemplatesManagementDialog( _props: ProjectTemplatesManagementDialogProps ){

    const props = { ...ProjectTemplatesManagementDialogDefaultProps, ..._props };

    const { showProjectTemplateEditDialog }       = useProject(),
          [ templateListing, setTemplateListing ] = useState<CorvalProjectTemplate[]>( [] ),
          [ showEditDialog, setShowEditDialog ]   = useState( false ),
          [ templateEditId, setTemplateEditId ]   = useState<Uuid>( null );

    const getTemplateListingQuery = SystemAccountingQueries.queries.GET_PROJECT_TEMPLATES(),
          getTemplateListingReq   = useQuery<{ me: { projectTemplates: CorvalProjectTemplate[] } }>( getTemplateListingQuery, { fetchPolicy: 'no-cache' } ),
          isLoading               = ( queriesLoading( [ getTemplateListingReq ] ) );

    useEffect( () => {

        setShowEditDialog( !_.isEmpty( templateEditId ) );

    }, [ templateEditId ] );

    useEffect( () => {

        if( !queriesLoading( getTemplateListingReq ) &&
            queriesHaveData( getTemplateListingReq ) ){

            setTemplateListing( getTemplateListingReq.data?.me.projectTemplates ?? [] );
        }

    }, [ getTemplateListingReq ] );


    const handleItemClicked = ( templateId: Uuid ) => {

        setTemplateEditId( templateId );
    };

    const handleItemEditClose: ProjectTemplateManagementDialogProps['onClose'] = async ( data ) => {

        setTemplateEditId( null );
    };

    const handleItemEditComplete: ProjectTemplateManagementDialogProps['onComplete'] = async ( data ) => {

        await getTemplateListingReq.refetch();

        runIfFunction( props.onComplete, getTemplateListingReq.data?.me?.projectTemplates ?? [] );

        // Optionally close the edit dialog
        // setShowEditDialog( false );
    };

    const handleOnComplete = async () => {

        await getTemplateListingReq.refetch();
    };

    return (

        <>


            {/* Next Steps Dialog (second modal) */ }
            <Modal open={ showEditDialog } size={ 'small' }>

                { templateEditId && (

                    <ProjectTemplateManagementDialog
                        autoClose={ false }
                        templateId={ templateEditId }
                        cancelLabel={ 'Close' }
                        onClose={ handleItemEditClose }
                        onComplete={ handleItemEditComplete }
                    />

                ) }

            </Modal>

            <BasicDialog
                { ...props }
                onComplete={ handleOnComplete }
                className={ 'no-padding' }
                overflow={ true }
                scrolling={ false }
                showSubmitButton={ false }
                cancelLabel={ 'Close' }
                controlAlign={ Align.CENTER }>

                <BasicDialogContainer
                    title={ 'Project Template Management' }
                    contentPadding={ Size.LG }
                    overflow={ true }
                    scrolling={ false }
                    roundedTop={ true }>

                    <UseIf x={ isLoading } eq={ true }>

                        <StyledContainer padding={ Size.LG }>
                            <LoadingIndicator label={ 'Loading Templates...' } isActive={ isLoading } inverted/>
                        </StyledContainer>

                    </UseIf>
                    <UseIf x={ isLoading } eq={ false }>

                        <TemplateListingWithSearch
                            items={ templateListing }
                            containerClasses={ 'overflow-content--y' }
                            containerStyles={ { maxHeight: '40dvh', minHeight: '40dvh' } }
                            onListItemClicked={ handleItemClicked }
                            showArchivedToggle={ true }
                            hideArchived={ true }
                        />

                    </UseIf>

                </BasicDialogContainer>

            </BasicDialog>
        </>
    );
}

export {
    ProjectTemplatesManagementDialog,
    ProjectTemplatesManagementDialogDefaultProps,
    type ProjectTemplatesManagementDialogProps
};
